// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function DatapointFormulaFromJSON(json) {
    return {
        'operator': json['operator'],
        'left': json['left'],
        'right': json['right'],
    };
}
export function DatapointFormulaToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'operator': value.operator,
        'left': value.left,
        'right': value.right,
    };
}
